module.exports = __webpack_public_path__ + "static/img/1022_small.6a2cf9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1022_small.png
// module id = euf0
// module chunks = 1